module.exports = __webpack_public_path__ + "img/nt52-03-80-1.prt.a4b895ab.jpg";